module.exports = __webpack_public_path__ + "assets/img/mobileCard1.07568e96.png";